import BoardUrls from './board';
import CommentUrls from './comment';
import ControlPassportUrls from './control-passport';
import TalkFlowUrls from './talk_flow';
import FTokFlows from './f-talk';
import MarketingAD from './marketing';
import EAS from './eas';
import RoleUrls from './role';
import FileUrls from './file';
import InteriorUrls from './interior';

export const apiURL = {
  ...InteriorUrls,
  ...BoardUrls,
  ...CommentUrls,
  ...ControlPassportUrls,
  ...TalkFlowUrls,
  ...FTokFlows,
  ...MarketingAD,
  ...EAS,
  ...RoleUrls,
  ...FileUrls,
};

export type ListMetaResponse = {
  currentPage: number;
  endPage: number;
  listSize: number;
  totalCount: number;
};
